import cart from './cart';
import utils from './utils';
import theme from './theme';
import product from './product';

export default ({
	cart, utils, theme, product
});
